import CreateBusiness from './CreateBusiness';

export default function CreateBusinessPage() {
  return (
    <CreateBusiness />
  );
}